import { render } from "./MakeDirectory.vue?vue&type=template&id=847588f6"
import script from "./MakeDirectory.vue?vue&type=script&lang=js"
export * from "./MakeDirectory.vue?vue&type=script&lang=js"

import "./MakeDirectory.vue?vue&type=style&index=0&id=847588f6&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__